import React from "react";

import { useCountyName } from "lib/api/distancing/data-summary";

import { Link } from "react-router-dom";

import DashboardBreadcrumbs from "components/DashboardBreadcrumbs";

export default function CountyLevelBreadcrumbs({ country, state, county }) {
  const names = useCountyName(country, state, county);

  if (names.data) {
    const { name_0, name_1, name_2 } = names.data;

    return (
      <DashboardBreadcrumbs>
        <Link to={`/distancing`} style={{ color: "inherit" }}>
          Latam
        </Link>
        <Link to={`/distancing/${country}`} style={{ color: "inherit" }}>
          {name_0}
        </Link>
        <Link to={`/distancing/${country}/${state}`} style={{ color: "inherit" }}>
          {name_1}
        </Link>
        {name_2}
      </DashboardBreadcrumbs>
    );
  }
  return <></>;
}
